import Text from '@eversports/react-components/primitives/Text'
import { assertNever } from '@eversports/utility-types'
import React from 'react'

import { Localized } from '../../localization/react'
import { CardType, UsageLimit, UsageLimitType } from '../../typings/Product'

interface Props {
  usages: Array<UsageLimit>
  cardType: CardType
}

interface BookingRulesProps {
  bookingRules: Array<UsageLimit>
}

const CardUsagesInformation: React.FC<React.PropsWithChildren<Props>> = ({ usages, cardType }) => {
  const totalLimitTypeUsages =
    cardType !== CardType.CARD_TYPE_EVENT_TIME
      ? usages.filter((usage) => usage.type === UsageLimitType.USAGE_LIMIT_TYPE_TOTAL)
      : []
  const repeatingAndPerBookingLimitTypeUsages = usages.filter(
    (usage) => usage.type !== UsageLimitType.USAGE_LIMIT_TYPE_TOTAL,
  )

  return (
    <>
      {totalLimitTypeUsages.map((usage, index) => (
        <div key={`${usage.type}-${index}`}>
          <Text size="small" color="subtleText">
            <Localized id="units-header" params={{ type: usage.unit as any }} />
          </Text>
          <Text>
            <Localized
              id="units"
              params={{ limit: usage.usageLimit, unit: usage.unit as any, currency: usage.currency || '' }}
            />
          </Text>
        </div>
      ))}
      {repeatingAndPerBookingLimitTypeUsages.length > 0 && (
        <BookingRules bookingRules={repeatingAndPerBookingLimitTypeUsages} />
      )}
    </>
  )
}

const BookingRules: React.FC<React.PropsWithChildren<BookingRulesProps>> = ({ bookingRules }) => (
  <div>
    <Text size="small" color="subtleText">
      <Localized id="booking-rules-header" />
    </Text>
    {bookingRules.map((usage, index) => {
      switch (usage.type) {
        case UsageLimitType.USAGE_LIMIT_TYPE_REPEATING:
          return (
            <Text key={`${usage.type}-${index}`}>
              <Localized
                id="product-booking-rules"
                params={{
                  intervalValue: usage.usageLimit,
                  intervalUnit: usage.unit as any,
                  interval: (
                    <Localized
                      id="interval"
                      params={{
                        intervalValue: usage.repeating!.interval.value,
                        intervalType: usage.repeating!.interval.type as any,
                      }}
                    />
                  ),
                }}
              />
            </Text>
          )
        case UsageLimitType.USAGE_LIMIT_TYPE_PER_BOOKING:
          return (
            <Text key={`${usage.type}-${index}`}>
              <Localized id="booking-limitation" params={{ limit: usage.usageLimit }} />
            </Text>
          )
        case UsageLimitType.USAGE_LIMIT_TYPE_TOTAL:
          // This never happens, it's just here to satisfy the type validation
          return null
        default:
          return assertNever(usage.type)
      }
    })}
  </div>
)

export default CardUsagesInformation
